(() => {
  const prepare = (root) => {
    root.querySelectorAll('.vr-category-preview').forEach((card) => {
      const image = card.querySelector('.vr-category-secondary');
      if (!image || image.dataset.hoverBound) return;
      image.dataset.hoverBound = 'true';
      const ready = () => card.classList.toggle('vr-category-hover-ready', image.complete && image.naturalWidth > 0);
      image.addEventListener('load', ready);
      image.addEventListener('error', () => card.classList.remove('vr-category-hover-ready'));
      ready();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepare(document), {once:true});
  } else {
    prepare(document);
  }
  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
})();
